import { AxiosInstance } from 'axios';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';
import { DataFetcherFunction } from '../../compiler/types';

export interface ExportOperation {
    id: string
    createdAt: string
    description: string
    userId: number
    progress: number
    filename: string
    failedAt: string | null
    failureMessage: string | null
}

export default (axios: AxiosInstance = baseAxios): { getOperations: DataFetcherFunction<ExportOperation>; fetchOperation: (operationId: string) => Promise<ExportOperation>; getDownloadUrlForOperation: (operationId: string) => Promise<string>; exportInventoryItems: () => Promise<ExportOperation>; exportCharges: () => Promise<ExportOperation>; exportChargeItems: (chargeId?: number | null) => Promise<ExportOperation>; exportListings: (channelId: number) => Promise<ExportOperation>; } => ({
    getOperations: fetchPaginatedDataFunction<ExportOperation>('/api/reports/exports/operations', undefined, axios),

    fetchOperation: async (operationId: string): Promise<ExportOperation> => {
        const response = await axios.get<{ data: ExportOperation }>(`/api/reports/exports/operations/${operationId}`);

        return response.data.data;
    },

    getDownloadUrlForOperation: async (operationId: string): Promise<string> => {
        const response = await axios.get<{ downloadUrl: string }>(`/api/reports/exports/operations/${operationId}/download`);

        return response.data.downloadUrl;
    },

    exportInventoryItems: async (): Promise<ExportOperation> => {
        const response = await axios.get<{ data: ExportOperation }>('/api/reports/exports/inventory');

        return response.data.data;
    },

    exportCharges: async (): Promise<ExportOperation> => {
        const response = await axios.get<{ data: ExportOperation }>('/api/reports/exports/charges');

        return response.data.data;
    },

    exportChargeItems: async (chargeId: number | null = null): Promise<ExportOperation> => {
        const url = new URL('/api/reports/exports/charge-items', location.origin);
        if (chargeId != null) {
            url.searchParams.append('charge_id', chargeId.toString());
        }

        const response = await axios.get<{ data: ExportOperation }>(url.toString());

        return response.data.data;
    },

    exportListings: async (channelId: number): Promise<ExportOperation> => {
        const response = await axios.get<{ data: ExportOperation }>(`/api/reports/exports/listings?channel_id=${channelId}`);

        return response.data.data;
    },
});
